import { assetContainerTypes } from '../actions/asset-container-action-types';

const initialState = {
	
	resort:false,
	originalValues: [],
	dragDropData: {}
};

export const assetContainer = (state = initialState, action) => {
	switch (action.type) {
		
			case assetContainerTypes.ASSET_CONTAINER_TOGGLE_RESORT:
			return{...state, resort: !this.state.resort};	
			case assetContainerTypes.ASSET_CONTAINER_START_RESORT:
			return{
				...state, 
				originalValues: action.originalValues,
				resort: true
			};
			case assetContainerTypes.ASSET_CONTAINER_STOP_RESORT:
			return{...state, resort: false};

		case assetContainerTypes.ASSET_CONTAINER_DRAG_START:
			return {...state, dragDropData: action.dragDropData}

		default:

			return state;
	}
};





// WEBPACK FOOTER //
// ./src/assetContainer/reducers/asset-container-reducers.js